<template>
  <div
    style="max-width: 20rem"
    :class="{'borders': $vuetify.breakpoint.smAndDown, 'd-flex flex-column': true}"
  >
    <v-btn
      height="38"
      color="primary"
      class="mt-0 mb-1"
      @click="fetchHealthCheck"
      :disabled="loading"
    >
      <template v-if="loading">
        <v-icon class="rotate" color="grey">mdi-loading</v-icon> Carregando...
      </template>
      <template v-else>
        Testar conexão com o levante
      </template>
    </v-btn>

    <template v-if="lastHealthCheck">
      <div class="d-flex mt-2">
        <p class="text-subtitle-1 mb-0">Último teste de conexão: {{ dayjs(lastHealthCheck.created_date).format("DD/MM/YYYY HH:mm") }}</p>

        <v-tooltip right max-width="300px">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on" class="ml-0">mdi-help-circle-outline</v-icon>
          </template>
          <span>
            {{ lastHealthCheck.description }}
          </span>
        </v-tooltip>
      </div>
    </template>
    <template v-else>
      Sem testes de conexão para este levante
    </template>
  </div>
</template>

<script>
import { PropType } from 'vue';

export default {
  name: 'HealthCheck',
  props: {
    lastHealthCheck: {
      type: Object,
      required: false
    },
    onClick: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    loading: false 
  }),
  methods: {
    async fetchHealthCheck() {
      this.loading = true

      try {
        await this.onClick()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
